import katex from "katex";

const LATEX_CONTENT_PATTERN =
  /\$\$[\s\S]*?\$\$|\\\([\s\S]*?\\\)|\\\[[\s\S]*?\\\]/;

const renderFormula = (formula, displayMode) => {
  try {
    return katex.renderToString(formula.trim(), {
      throwOnError: false,
      displayMode,
    });
  } catch (err) {
    return `<span class="latex-error">Invalid LaTeX</span>`;
  }
};

const renderPattern = (html, pattern, displayMode) =>
  html.replace(pattern, (_, formula) => renderFormula(formula, displayMode));

export const renderLatexInHtml = (html = "") => {
  let renderedHtml = html;

  renderedHtml = renderPattern(
    renderedHtml,
    /\$\$([\s\S]*?)\$\$/g,
    true,
  );
  renderedHtml = renderPattern(
    renderedHtml,
    /\\\[([\s\S]*?)\\\]/g,
    true,
  );
  renderedHtml = renderPattern(
    renderedHtml,
    /\\\(([\s\S]*?)\\\)/g,
    false,
  );

  return renderedHtml;
};

export const hasLatexContent = (value = "") =>
  LATEX_CONTENT_PATTERN.test(value);
